<template>
  <ul class="navbar" :class="getClasses" :style="getStyles">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  props: {
    absolute: Boolean,
    bottom: Boolean,
    isOnProject: Boolean,
    equalItems: Boolean,
    hiddenOnMobile: Boolean,
    flexEnd: Boolean,
    textColor: String,
    noPointerEvents: Boolean,
  },
  computed: {
    getStyles() {
      return {
        "--text-color": this.textColor ? this.textColor : null,
      };
    },
    getClasses() {
      return {
        project: this.project,
        absolute: this.absolute,
        bottom: this.bottom,
        "hidden-on-mobile": this.hiddenOnMobile,
        "is-on-project": this.isOnProject,
        "equal-items": this.equalItems,
        "flex-end": this.flexEnd,
        "no-pointer-events": this.noPointerEvents,
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";

.navbar {
  margin: 0;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  list-style: none;
  width: 100%;
  box-sizing: border-box;
  z-index: var(--z-index-topbar);

  font-family: var(--topbar-font-family);
  letter-spacing: var(--topbar-letter-spacing);
  font-weight: var(--topbar-font-weight);

  @include breakpoint(xs) {
    font-size: var(--topbar-font-size-mobile);
    line-height: var(--topbar-line-height-mobile);
    padding: var(--topbar-padding-mobile);
  }

  @include breakpoint(sm) {
    font-size: var(--topbar-font-size-tablet);
    line-height: var(--topbar-line-height-tablet);
    padding: var(--topbar-padding-tablet);
  }

  @include breakpoint(md) {
    font-size: var(--topbar-font-size);
    line-height: var(--topbar-line-height);
    padding: var(--topbar-padding);
  }

  &.is-on-project {
    @include breakpoint(xs) {
      color: inherit !important;
      mix-blend-mode: normal !important;
    }
  }

  &.hidden-on-mobile {
    @include breakpoint(xs) {
      display: none;
    }
  }

  &.absolute {
    position: absolute;
    color: white;
    mix-blend-mode: difference;

    &.bottom {
      bottom: 0;
    }

    a {
      &:after {
        background-color: white;
      }
    }
  }

  &.equal-items {
    li {
      flex-basis: 0;
      flex-grow: 1;
    }
  }

  &.flex-end {
    justify-content: flex-end;
  }

  &.no-pointer-events {
    pointer-events: none;
  }

  li {
    margin: 0;
    padding: 0;

    &.text-center {
      text-align: center;
    }

    &.text-right {
      text-align: right;
    }

    &.narrow {
      flex-grow: 0.5;
    }

    &.wide {
      flex-grow: 2;
      text-align: right;
    }

    p {
      margin: 0;
    }

    a {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        height: 1px;
        background: var(--text-color, #000);
        bottom: 0px;
        transition: all
          var(--small-animations-duration) var(--small-animations-easing);
        right: 0;
        width: 0;
      }

      &:hover {
        &:after {
          left: 0;
          right: auto;
          width: 100%;
        }
      }
    }
  }

  @include breakpoint(xs) {
    .last-on-mobile {
      order: 3;
      flex-basis: 100% !important;
      margin-top: 30px;
      text-align: inherit !important;
    }

    .narrow-on-mobile {
      flex-grow: 2;
    }
  }
}
</style>